<template>
  <FaIcon :icon="['fas', 'timer']" />
</template>
